<template>

<core-panel>

	<template v-slot:head>

		<h1>Widely Played</h1>

		<p>The games played with the most different players.</p>

	</template>

	<template v-slot:body>

		<app-game v-for="(item, index) in games" :count="item.players" countText="players" :playsAsSubtext="true" :item="item" v-bind:key="index" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'games',
			games: []
		}

	},

	methods: {

		response: function(json) {

			this.games = json.games.games

		}

	}

}

</script>